import React, { useEffect, useState, useMemo } from "react";
import { Table, Layout, Descriptions, Card, Collapse, Typography, message, Tooltip, Modal, Button, DatePicker, Space } from 'antd';
import { getHeader, getPOA, getPOPeso, updateAvance, updateFecha, updatePeso } from '../../services/plaOperativo/headerPlanOperativoServices';
import { ColumnHeightOutlined, EyeOutlined, TableOutlined, LinkOutlined, InfoCircleOutlined, MenuOutlined, MoreOutlined, ArrowLeftOutlined, WarningOutlined } from '@ant-design/icons';
import { fetchPoaData } from '../../services/poa/get_poa';
import FileManagerPOA2 from './FileManagerPP';
import FileManagerPOA from '../Poa/FileManagerPOA';
import EditableCell from './EditableCell';
import './PoaPlanOperativoTable.css';
import moment from 'moment';
import dayjs from 'dayjs';
import Ippta from '../Ippta/Ippta';
import Edah from '../EncuestaEdah/Edah';
import TablaAvanceJSX from './TablaResumenAvance.jsx'
import { selectAppPermissions } from '../../store/auth/selectors.js';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getZonasProyectosPOA } from '../../services/Producto_2/Implementacion/Fao/Relacion_Proyecto_Zona/relacionProyectoZona';

const { Title } = Typography;

const MESES_LISTA = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

const COLORES_CRONOGRAMA = ['#408cc8', '#198754', '#eea72c', '#6f42c1', '#e83e8c', '#20c997', '#fd7e14', '#dc3545'];

const PoaPlanOperativoTB = ({ selectedFase, selectedProject, regresarAnterior, cerrarModal }) => {

  const [headerPO, setHeaderPO] = useState({});
  const [loading, setLoading] = useState(true);
  const [actividades, setActividades] = useState([]);
  const [error, setError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [actividadSelect, setActividadSelect] = useState(null);
  // Solo la tarea de Informe Técnico Final debe habilitar la exportación de
  // árbol dentro de FileManagerPP; su código de tarea/indicador varía por
  // proyecto, así que se identifica por el texto del indicador, igual que
  // hace el backend en informeFinalPlanOperativoModel.ts
  // (LOWER(pi.indicador) LIKE '%informe%final%').
  const [esInformeFinalSoporte, setEsInformeFinalSoporte] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [itemParams, setItemParams] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const [mesConfigPorAnio, setMesConfigPorAnio] = useState({});

  const [columnasFinales, setColumnasFinales] = useState([]);
  const [tareasSubtareas, setTareasSubtareas] = useState([]);
  const [editingDate, setEditingDate] = useState(false);
  const [opcionFiltro, setOpcionFiltro] = useState(null);
  const [codigoProyecto, setCodigoProyecto] = useState(null);
  const [isModalVisibleParticipantes, setIsModalVisibleParticipantes] = useState(false);
  const [banderaProyecto, setBanderaProyecto] = useState([]);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [valoresJsonPeso, setValoresJsonPeso] = useState([]);
  const [rawPesoData, setRawPesoData] = useState([]);
  const [mostrarTablaResumen, setMostrarTablaResumen] = useState(true);
  const [mostrarTablaCronograma, setMostrarTablaCronograma] = useState(true);
  const [isVisibleTarea, setIsVisibleTarea] = useState(true);
  const [pesoTotal, setPesoTotal] = useState(0);
  const [tipoFase, setTipoFase] = useState(false);

  const appName = 'poa_plan_operativo';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));

  const permissionInsert = permissions.priv_insert === 'Y'; //Tabla y fecha Actualizacion
  //const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';  //Soportes
  //const permissionExport = permissions.priv_export === 'Y';
  const permissionView = permissions.priv_print === 'Y'; // Peso Prcentual
  const permissionPrint = permissions.priv_print === 'Y';
  const navigate = useNavigate();

  useEffect(() => {
    setMesConfigPorAnio({});
    setColumnasFinales([]);
  }, [selectedProject.oid]);


  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data } = await getHeader(selectedProject.oid);
        setHeaderPO(data?.encabezado[0]);
        setError(false);
      } catch (error) {
        setError(true);
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [selectedProject.oid]);



  useEffect(() => {
    const fetchPOA = async () => {
      setLoading(true);
      try {
        // Reiniciamos los estados
        setActividades([]);
        setValoresJsonPeso([]);
        setTareasSubtareas([]);
        // Llamada al primer servicio
        const { data: poaData } = await getPOA(selectedFase.oid, selectedProject.oid);
        // Verificamos que poaData sea un array (o tenga la estructura que esperamos)
        if (!Array.isArray(poaData)) {
          throw new Error("Los datos de POA no son válidos");
        }
        // Si el primer servicio fue exitoso, entonces ejecutamos el segundo:

        const dataJSONPeso = await getPOPeso(selectedFase.oid, selectedProject.oid, 'filtrado');
        const esFase3 = selectedFase.oid === 3;
        setTipoFase(esFase3);
        if (!tipoFase) {
          const { status, data: body } = dataJSONPeso;
          if (status === 200 && body.status === 200 && Array.isArray(body.data)) {

            const pesoArray = dataJSONPeso.data.data;

            const valoresJsonPeso = logTotPesoPorMesAnioPorFase(pesoArray);

            const pesoTotal = parseFloat(pesoArray[0].totalPeso)
            setPesoTotal(pesoTotal);
            setValoresJsonPeso(valoresJsonPeso);
            setRawPesoData(pesoArray);

          } else {
            throw new Error("Los datos de Peso no son válidos");
          }
        }

        // Actualizamos estados con los datos obtenidos
        actualizarMeses(poaData);
        setActividades(poaData);
        setTareasSubtareas(mapTareasSubtareas(poaData));

      } catch (error) {
        console.error("Error fetching POA:", error);
        setActividades([]);
        setValoresJsonPeso([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedFase?.oid && selectedProject?.oid) {
      fetchPOA();
    }
  }, [selectedFase.oid, selectedProject.oid]);

  useEffect(() => {
    if (rawPesoData) {
      const nuevosTotales = logTotPesoPorMesAnioPorFase(rawPesoData);
      setValoresJsonPeso(nuevosTotales);
    }
  }, [rawPesoData]);


  useEffect(() => {
    const columnasCronograma = [];
    setColumnasFinales([]);

    Object.entries(mesConfigPorAnio)
      .sort(([a], [b]) => a.localeCompare(b))
      .forEach(([anio, { mesInicial, meses }]) => {
        if (meses.length > 0 && mesInicial) {
          const columnas = generarColumnasDinamicas(meses, mesInicial, anio, valoresJsonPeso);
          if (columnas.length > 0) {
            columnasCronograma.push({
              title: `Cronograma ${anio}`,
              className: `color-cronograma-${anio}`,
              children: columnas,
            });
          }
        }
      });

    setColumnasFinales(columnasCronograma);
  }, [mesConfigPorAnio, valoresJsonPeso]); // eslint-disable-line react-hooks/exhaustive-deps



  const totalPesoFase = useMemo(() => {
    return actividades.reduce((totalActividad, actividad) => {
      if (actividad.children && Array.isArray(actividad.children)) {
        // Sumamos el pesoPorcentual de cada tarea de la actividad.
        const sumaTareas = actividad.children.reduce((sumTarea, tarea) => {

          return sumTarea + Number(tarea.pesoPorcentual || 0);
        }, 0);
        return totalActividad + sumaTareas;
      }
      return totalActividad;
    }, 0);
  }, [actividades]);

  const estilosDinamicosAnios = useMemo(() => {
    return Object.keys(mesConfigPorAnio)
      .sort()
      .map((anio, index) => {
        const color = COLORES_CRONOGRAMA[index % COLORES_CRONOGRAMA.length];
        return `.ant-table-thead > tr > th.color-cronograma-${anio} { background-color: ${color} !important; color: white !important; }`;
      })
      .join('\n');
  }, [mesConfigPorAnio]);


  function capitalizarPrimeraLetra(texto) {
    return texto.toLowerCase().charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
  }

  function getIdByMonthAndYear(month, year, cronogramas, id_indicador) {
    const cronograma = cronogramas.find(c => c.mes === month && c.ano === year && c.indicador_id === id_indicador);
    return cronograma ? cronograma.id : null; // Retorna el id si lo encuentra, de lo contrario null
  }

  function logTotPesoPorMesAnioPorFase(dataJSONPeso) {

    // Objeto que guardará los acumuladores por fase, subdivididos en P y E.
    // Ej: acumuladoresPorFase[faseId] = { P: {}, E: {} }
    const acumuladoresPorFase = {};

    // Recorremos las "fases" (elementos del array dataJSONPeso)
    dataJSONPeso.forEach((fase) => {
      const faseId = fase.fase_id || "fase-sin-id";

      // Si no existe, inicializamos la estructura con P y E vacíos
      if (!acumuladoresPorFase[faseId]) {
        acumuladoresPorFase[faseId] = {
          P: {},
          E: {},
        };
      }

      if (!fase.children) return; // Sin actividades, skip

      fase.children.forEach((tarea) => {
        // Ajusta si tu "pesoPorcentual" es realmente un factor o un %.
        // Aquí supongo que lo usas "tal cual":
        const pesoEntero = parseFloat(tarea.pesoPorcentual) || 0;
        const peso = pesoEntero / 1; // o /100 si en BD 3 significa 3%

        if (!tarea.children) return; // Sin indicadores, skip

        tarea.children.forEach((indicador) => {
          const meta = parseFloat(indicador.meta) || 0;
          if (meta <= 0 || peso <= 0) return; // Evitar /0

          // --- PROYECTADO (P) ---
          if (indicador.cronogramasP) {
            indicador.cronogramasP.forEach((crono) => {
              const p = parseFloat(crono.avance) || 0;
              const mes = crono.mes;
              const ano = crono.ano;
              const keyMesAnio = `${mes}-${ano}`;

              const parcial = (p / meta) * peso;

              if (!acumuladoresPorFase[faseId].P[keyMesAnio]) {
                acumuladoresPorFase[faseId].P[keyMesAnio] = 0;
              }
              acumuladoresPorFase[faseId].P[keyMesAnio] += parcial;
            });
          }

          // --- EJECUTADO (E) ---
          if (indicador.cronogramasE) {
            indicador.cronogramasE.forEach((crono) => {
              const e = parseFloat(crono.avance) || 0;
              const mes = crono.mes;
              const ano = crono.ano;
              const keyMesAnio = `${mes}-${ano}`;

              const parcial = (e / meta) * peso;

              if (!acumuladoresPorFase[faseId].E[keyMesAnio]) {
                acumuladoresPorFase[faseId].E[keyMesAnio] = 0;
              }
              acumuladoresPorFase[faseId].E[keyMesAnio] += parcial;
            });
          }
        });
      });
    });

    // *** REDONDEO AL FINAL ***
    // Recorremos cada fase, y dentro de cada fase, cada tipo (P, E) y cada "mes-año"
    for (const faseId in acumuladoresPorFase) {
      for (const tipo of ["P", "E"]) {
        for (const keyMesAnio in acumuladoresPorFase[faseId][tipo]) {
          const valorAcumulado = acumuladoresPorFase[faseId][tipo][keyMesAnio];
          // Redondear a 2 decimales
          acumuladoresPorFase[faseId][tipo][keyMesAnio] = Number(
            valorAcumulado.toFixed(2)
          );
        }
      }
    }

    // Ahora construimos un objeto JSON con el formato deseado
    // (ej. "fase" y luego "p" y "e" separadas)
    const resultado = { fases: [] };

    for (const [faseId, objPE] of Object.entries(acumuladoresPorFase)) {
      // objPE = { P: {...}, E: {...} }
      resultado.fases.push({
        fase: faseId,
        p: objPE.P,
        e: objPE.E,
      });
    }

    // Devolver el objeto JSON para usarlo en otra parte
    return resultado;
  }

  // Función para alternar la visibilidad de la tabla de resumen
  const toggleTablaResumen = () => {
    setIsVisible(false);
    // Si actualmente la tabla resumen está visible y la de cronograma está oculta,
    // evitar ocultar la de resumen porque así ambas quedarían ocultas.
    if (mostrarTablaResumen && !mostrarTablaCronograma) {
      return;
    }
    setMostrarTablaResumen(prev => !prev);
  };

  // Función para alternar la visibilidad de la tabla de cronograma
  const toggleTablaCronograma = () => {
    setIsVisible(false);
    if (mostrarTablaCronograma && !mostrarTablaResumen) {
      return;
    }
    setMostrarTablaCronograma(prev => !prev);
  };

  const toggleVisibilityTarea = () => {
    setIsVisibleTarea(!isVisibleTarea); // Cambiar el estado entre visible y oculto
  };



  const updateAvanceInRaw = (jsonArray, key, newValue) => {
    return jsonArray.map((actividad) => ({
      ...actividad,
      children: actividad.children?.map((tarea) => ({
        ...tarea,
        children: tarea.children?.map((indicador) => ({
          ...indicador,
          cronogramasP: indicador.cronogramasP?.map((crono) =>
            crono.id === Number(key) ? { ...crono, avance: newValue } : crono
          ),
          cronogramasE: indicador.cronogramasE?.map((crono) =>
            crono.id === Number(key) ? { ...crono, avance: newValue } : crono
          ),
        })),
      })),
    }));
  };



  const generarColumnasDinamicas = (meses, mesInicial, ano, valoresJsonPeso) => {
    const mesInicialIndex = meses.indexOf(mesInicial);
    if (mesInicialIndex === -1) return [];
    return meses.slice(mesInicialIndex).map((mes) => {
      // Construir la clave en formato "MES-ANO", por ejemplo: "AGO-2024"
      const keyMesAno = `${mes.toUpperCase()}-${ano}`;
      // Extraer valor para tipo "P"
      let valorP = "-";
      if (
        valoresJsonPeso &&
        valoresJsonPeso.fases &&
        valoresJsonPeso.fases.length > 0 &&
        valoresJsonPeso.fases[0].p
      ) {
        const tmp = valoresJsonPeso.fases[0].p[keyMesAno];
        if (tmp !== undefined) {
          valorP = tmp;
        } else {
          valorP = 0;
        }
      }
      // Extraer valor para tipo "E"
      let valorE = "-";
      if (
        valoresJsonPeso &&
        valoresJsonPeso.fases &&
        valoresJsonPeso.fases.length > 0 &&
        valoresJsonPeso.fases[0].e
      ) {
        const tmpE = valoresJsonPeso.fases[0].e[keyMesAno];
        if (tmpE !== undefined) {
          valorE = tmpE;
        } else {
          valorE = 0;
        }
      }
      return [
        // Columna para tipo "P"

        {
          title: (
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <span>{mes}</span>
              {!tipoFase && (
                <span
                  style={{
                    marginTop: '4px',
                    paddingTop: '4px',
                    borderTop: '1px solid #ccc',
                    fontSize: 12,
                    color: '#ffc107',
                  }}
                >
                  {valorP}%
                </span>
              )}
            </div>
          ),
          dataIndex: `${mes.toLowerCase()}${ano}`, // ej.: "ago2024"
          key: `key${capitalizarPrimeraLetra(mes)}${ano}`,
          width: 100,
          align: 'center',
          render: (text) => {
            const numValue = parseFloat(text);
            if (isNaN(numValue)) {
              return text;
            }

            // Si es entero, mostramos sin decimales
            const formattedValue = Number.isInteger(numValue)
              ? Math.trunc(numValue)
              : numValue.toFixed(2); // siempre 2 decimales

            return (
              <div
                style={{
                  backgroundColor: numValue >= 1 ? '#96BEEF' : 'transparent',
                  color: numValue >= 1 ? '#FFFFFF' : 'inherit',
                }}
              >
                {formattedValue}
              </div>
            );
          },

          onCell: (record, rowIndex) => ({
            record,
            dataIndex: `${mes.toLowerCase()}${ano}`, // la clave que se actualizará
            editable: permissionInsert && rowIndex % 2 !== 0,
            handleSave: (updatedRecord) =>
              handleSave(updatedRecord, record[`key${capitalizarPrimeraLetra(mes)}${ano}`], `${mes.toLowerCase()}${ano}`),
          }),
        },
        // Columna para tipo "E"
        {
          title: (
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <span>% Avance</span>
              {!tipoFase && (
                <span
                  style={{
                    marginTop: '4px',
                    paddingTop: '4px',
                    borderTop: '1px solid #ccc',
                    fontSize: 12,
                    color: '#ffc107',
                  }}
                >
                  {valorE}%
                </span>
              )}
            </div>
          ),
          dataIndex: `avance${capitalizarPrimeraLetra(mes)}${ano}`, // ej.: "avanceAgo2024"
          key: `avance${capitalizarPrimeraLetra(mes)}${ano}`,
          width: 100,
          align: 'center',
          editable: true,
          render: (text, record, rowIndex) => {
            // Puedes ajustar este render según cómo quieras mostrar los datos de E
            return <div>{text}</div>;
          },
          onCell: (record, rowIndex) => ({
            rowSpan: rowIndex % 2 === 0 ? 2 : 0,
          }),
        },
      ];
    }).flat();
  };

  const generarMeses = (mesInicio, mesFin) => {
    const indiceInicio = MESES_LISTA.indexOf(mesInicio);
    const indiceFin = MESES_LISTA.indexOf(mesFin);
    if (indiceInicio === -1 || indiceFin === -1) return [];
    return MESES_LISTA.slice(indiceInicio, indiceFin + 1);
  };

  const actualizarMeses = (data) => {
    const config = {};

    data.forEach(actividad => {
      actividad.children.forEach(tarea => {
        tarea.children.forEach(item => {
          item.cronogramaconfig.forEach(cronConfig => {
            const { anio } = cronConfig;
            if (!config[anio]) {
              config[anio] = {
                mesInicial: cronConfig.mes_inicio,
                meses: generarMeses(cronConfig.mes_inicio, cronConfig.mes_final),
              };
            }
          });
        });
      });
    });

    setMesConfigPorAnio(config);
  };

  const formatDate = (date) => {
    if (!date) return "Sin fecha";

    try {
      const localDate = new Date(date + "T00:00:00"); // Forzar la hora a medianoche
      return localDate.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
    } catch {
      return "Formato inválido";
    }
  };

  const calcularAvance = (avanceP, avanceE) => {
    if (avanceP && avanceE) {
      if (avanceP === 0 || avanceP === '-' || avanceE === 0) return '0%';
      const sumaTotalP = parseFloat(avanceP);
      const sumaTotalE = parseFloat(avanceE);
      if (sumaTotalP === 0) return '0%';
      return `${((sumaTotalE / sumaTotalP) * 100).toFixed(0)}%`;
    }
    return '0%';
  };

  const handleCancelParticipantes = () => {
    setIsModalVisibleParticipantes(false);
  };

  const handleClickBasedOnURL = (component, record) => {
    if (component.includes("sistematizacionIppta")) {
      setOpcionFiltro(1);
      setCodigoProyecto(record.proyecto);
      setIsModalVisibleParticipantes(true);
    } else if (component.includes("encuestaEdah")) {
      setOpcionFiltro(2);
      setCodigoProyecto(record.proyecto);
      setIsModalVisibleParticipantes(true);
    } else if (component.includes("repositorio-documental")) {
      navigate(`/repositorio-documental/${record.proyecto}`);
    }
    else {
      procesarMpoa(component, record);
    }
  };

  const renderComponent = () => {
    switch (opcionFiltro) {
      case 1:
        return <Ippta proyectoCodigo={codigoProyecto} />;
      case 2:
        return <Edah proyectoCodigo={codigoProyecto} />;
      default:
        return null;
    }
  };


  const mapTareasSubtareas = (actividades) => {
    return actividades.flatMap((actividad) => {
      if (actividad.children && Array.isArray(actividad.children)) {
        return actividad.children.flatMap((tarea) =>
          tarea.children ? tarea.children.map((subtarea) => {
            const rowData = {
              fechaFinReal: formatDate(subtarea.medios_verificacion[0]?.fecha_fin_real),
              medioVerificacion: subtarea.medios_verificacion[0]?.medio_verificacion || '-',
              observacion: subtarea.medios_verificacion[0]?.observacion || '-',
              ruta: subtarea.medios_verificacion[0]?.ruta || '-',
            };
            const cronogramasP = subtarea.cronogramasP || [];
            const cronogramasE = subtarea.cronogramasE || [];

            const getAvance = (mes, cronogramas, ano) => {
              const c = cronogramas.find(c => c.mes === mes && c.ano === ano);
              return c ? c.avance : '-';
            };

            const sumarAvances = (datos) =>
              datos.reduce((sum, c) => {
                const v = parseFloat(c.avance);
                return sum + (isNaN(v) ? 0 : v);
              }, 0);

            const sumaP = sumarAvances(cronogramasP);
            const sumaE = sumarAvances(cronogramasE);
            const avanceAcu = sumaP !== 0 ? `${((sumaE / sumaP) * 100).toFixed(0)}%` : '0%';

            // Derivar los años configurados de cronogramaconfig para garantizar cobertura completa
            const todosAnios = [...new Set([
              ...(subtarea.cronogramaconfig?.map(c => c.anio) || []),
              ...cronogramasP.map(c => c.ano),
              ...cronogramasE.map(c => c.ano),
            ])].sort();

            // Construir campos dinámicos mes/año para filas P y E
            const camposP = {};
            const camposE = {};

            todosAnios.forEach(ano => {
              MESES_LISTA.forEach(mes => {
                const mesLow = mes.toLowerCase();
                const mesCap = capitalizarPrimeraLetra(mes);
                camposP[`${mesLow}${ano}`] = getAvance(mes, cronogramasP, ano);
                camposP[`key${mesCap}${ano}`] = getIdByMonthAndYear(mes, ano, cronogramasP, subtarea.id);
                camposE[`${mesLow}${ano}`] = getAvance(mes, cronogramasE, ano);
                camposE[`key${mesCap}${ano}`] = getIdByMonthAndYear(mes, ano, cronogramasE, subtarea.id);
              });
            });

            // Calcular porcentajes de avance por mes/año
            todosAnios.forEach(ano => {
              MESES_LISTA.forEach(mes => {
                const mesLow = mes.toLowerCase();
                const mesCap = capitalizarPrimeraLetra(mes);
                camposP[`avance${mesCap}${ano}`] = calcularAvance(camposP[`${mesLow}${ano}`], camposE[`${mesLow}${ano}`]);
                camposE[`avance${mesCap}${ano}`] = calcularAvance(camposE[`${mesLow}${ano}`], camposP[`${mesLow}${ano}`]);
              });
            });
            return [
              {
                key: `subtarea-${subtarea.id}-1`,
                proyecto: selectedProject.codigo,
                oidActividad: actividad.id,
                codActividad: actividad.codigo_actividad,
                oidTarea: tarea.id,
                codTarea: tarea.codigo_tarea,
                codIndicador: subtarea.id,
                codMV: subtarea.medio_verificacion_id,
                tarea: `${tarea.codigo_tarea} - ${tarea.descripcion}`,
                indicador: subtarea.indicador,
                meta: subtarea.meta,
                pesoPorcentual: tarea.pesoPorcentual,
                fechaInicio: formatDate(subtarea.fecha_inicio),
                fechaFin: formatDate(subtarea.fecha_fin),
                pe: 'P',
                ...camposP,
                metaAcu: sumaP,
                avanceAcu,
                fechaFinReal: formatDate(subtarea.fecha_f_real),
                medioVerificacion: rowData.medioVerificacion,
                observacion: rowData.observacion,
                ruta: subtarea.ruta,
                actividad: actividad.descripcion,
              },
              {
                key: `subtarea-${subtarea.id}-2`,
                oidActividad: actividad.id,
                pesoPorcentual: tarea.pesoPorcentual,
                proyecto: '',
                codIndicador: '',
                codActividad: '',
                codTarea: '',
                oidTarea: tarea.id,
                codMV: '',
                tarea: '',
                indicador: '',
                meta: '',
                fechaInicio: '',
                fechaFin: '',
                pe: 'E',
                ...camposE,
                metaAcu: sumaE,
                avanceAcu,
                fechaFinReal: rowData.fechaFinReal,
                medioVerificacion: '',
                observacion: '',
                ruta: '',
                actividad: '',
              },
            ];
          }) : []
        );
      }
      return [];
    }).flat();
  };

  const procesarMpoa = async (url, valor) => {
    if (url) {
      const Mpoa = url.split("/poa/")[1];

      if (Mpoa === '2.2.1') {
        return null;
      }
      // Función para determinar qué actividad es especial y cómo manejarla
      const manejarActividadEspecial = (actividad) => {
        switch (actividad) {
          case '2.2.1.1':
            return '2.2.1'; // Se usa como base para encontrar nodos relacionados
          case '2.2.1.2':
            return '2.2.1'; // Se usa como base para encontrar nodos relacionados
          case '2.2.1.3':
            return '2.2.1'; // Se usa como base para encontrar nodos relacionados
          case '2.3.1.1':
          case '2.3.1.2':
          case '2.3.1.3':
            return '2.3.1'; // Se usa como base para encontrar nodos relacionados
          default:
            return actividad; // Para actividades normales, retorna el valor original
        }
      };
      const actividadBase = manejarActividadEspecial(Mpoa);
      // Códigos de 4 niveles que apuntan a un indicador puntual dentro de la tarea base
      const indicadorEspecial = {
        '2.2.1.2': 'indicador_33',
        '2.2.1.3': 'indicador_34',
        '2.3.1.1': 'indicador_38',
        '2.3.1.2': 'indicador_39',
        '2.3.1.3': 'indicador_40',
      }[Mpoa];

      try {
        const dataCompleta = await fetchPoaData();
        const dataPoa = dataCompleta.dataPoa;
        const findNodePath = (node, path = []) => {
          path.push(node);
          if (node.codigo_tarea === actividadBase && !indicadorEspecial) {
            return path;
          }
          if (indicadorEspecial) {
            if (node.children && node.children.length > 0) {
              for (let child of node.children) {
                if (child.key === indicadorEspecial) {
                  path.push(child);
                  return path;
                }
              }
            }
          }
          if (node.children && node.children.length > 0) {
            for (let child of node.children) {
              const result = findNodePath(child, [...path]);
              if (result) return result;
            }
          }
          return null;
        };
        let matchedPath = null;

        for (let nodo of dataPoa) {
          matchedPath = findNodePath(nodo);
          if (matchedPath) break;
        }
        if (matchedPath) {
          const initialData = extractData(matchedPath);
          const actividadData = initialData[0].actividadData;
          const tareaEncontrada = actividadData.find((item) => {
            if (indicadorEspecial) {
              return item.codigo_tarea === actividadBase && item.key === indicadorEspecial;
            }
            return item.codigo_tarea === actividadBase;
          });
          if (tareaEncontrada) {

            //Zonas
            let zonasValue = "";
            if (tareaEncontrada.codActividad === "4.1" && tareaEncontrada.codigo_tarea === "4.1.2") {
              try {
                const proyectoLimpio = valor.proyecto?.replace(/\D/g, '') || '';
                const data = await getZonasProyectosPOA(proyectoLimpio);
                if (data && data.length > 0 && data[0].carpeta) {
                  zonasValue = data[0].carpeta;
                } else {
                  console.warn("No se encontraron datos de zona.");
                }
              } catch (error) {
                console.error('Error al cargar zonas:', error);
              }
            } else {
              zonasValue = "";
            }
            tareaEncontrada.proyecto = valor.proyecto;
            tareaEncontrada.banderaZonas = zonasValue;
            setBanderaProyecto(selectedProject.codigo);
            setOpenModal1(true);
            setItemParams(tareaEncontrada);
          } else {
            setOpenModal1(false);
            setItemParams(null);
          }
        } else {
          console.warn("No se encontró ningún nodo coincidente");
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    } else {
      setOpenModal1(false);
    }
  };

  const extractData = (children) => {
    return children.flatMap(child => {
      if (child.children && child.tipo === 'Actividad') {
        const actividadData = child.children.flatMap(grandchild => {
          if (grandchild.children && grandchild.tipo === 'Tarea') {
            return grandchild.children.flatMap(greatGrandchild => {
              if (greatGrandchild.tipo === 'Indicador') {
                const fecha = greatGrandchild.meta_e?.[0]?.fecha;
                const fechaFormateada = fecha ? new Date(fecha).toLocaleDateString('es-ES') : '-';
                const metaProyectada = greatGrandchild.meta_proyectada || 0;
                const valorEjecutado = Math.floor((greatGrandchild.meta_e?.reduce((total, meta) => total + meta.valor, 0) || 0) * 100) / 100;
                const porcentajeEjecucion = metaProyectada > 0 ? (valorEjecutado / metaProyectada) * 100 : 0;
                const medioV = greatGrandchild.medioVerificacion || null;
                return {
                  key: greatGrandchild.key,
                  codigo_tarea: grandchild.codigo_tarea,
                  codActividad: grandchild.codActividad,
                  nameActividad: child.actividad,
                  tarea: grandchild.tarea,
                  indicador: greatGrandchild.title,
                  medioV: medioV,
                  meta_proyectada: metaProyectada,
                  valorEjecutado: valorEjecutado,
                  porcentaje_ejecucion: porcentajeEjecucion % 1 === 0 ? porcentajeEjecucion.toFixed(0) : porcentajeEjecucion.toFixed(1),
                  porcentaje_avance: greatGrandchild.meta_e?.[0]?.valor || 'N/A',
                  fechas: fechaFormateada,
                  responsables: 'N/A',
                  soportes: 'N/A',
                  datoIndicador: greatGrandchild,
                };
              }
              return [];
            });
          }
          return [];
        });

        const totalMetaProyectada = actividadData.reduce((total, data) => total + (data.meta_proyectada || 0), 0);
        const totalValorEjecutado = actividadData.reduce((total, data) => total + (data.meta_proyectada * (parseFloat(data.porcentaje_ejecucion) / 100) || 0), 0);
        const porcentajeEjecucionActividad = totalMetaProyectada > 0 ? (totalValorEjecutado / totalMetaProyectada) * 100 : 0;

        return [{
          actividadTitle: child.title,
          actividad: child.actividad,
          porcentajeEjecucionActividad: porcentajeEjecucionActividad.toFixed(1),
          actividadData: actividadData
        }];
      }
      return [];
    });
  };

  const hideModalMedios = () => {
    setBanderaProyecto(null);
    setOpenModal1(false);
    setItemParams(null);
  };

  if (loading) return <div>Loading...</div>;

  if (error) {
    return <div>El proyecto no existe o no se encontró información.</div>;
  }

  const formatDateToText = (dateString) => {
    if (!dateString) return ''; // Evita errores si la fecha es nula o indefinida

    // Descomponer la fecha "YYYY-MM-DD"
    const [year, month, day] = dateString.split('-');

    // Crear objeto Date en formato local
    const date = new Date(Number(year), Number(month) - 1, Number(day));

    return date.toLocaleDateString('es-CO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const tieneFechaActualTerminacion =
    headerPO?.fecha_actual_terminacion &&
    headerPO.fecha_actual_terminacion !== '0000-00-00';

  const items = [
    {
      key: '1',
      span: 3,
      label: (
        <div style={{ textAlign: 'left', fontWeight: 'bold' }}>
          {headerPO?.titulo || 'Nombre del Proyecto no disponible'}
        </div>
      ),
    },
    {
      key: '2',
      span: 3,
      label: (
        <div style={{ textAlign: 'left' }}>
          {headerPO?.convenio || 'Convenio no disponible'}
        </div>
      ),
    },
    {
      key: '3',
      span: 3,
      label: (
        <div style={{ textAlign: 'left' }}>
          {headerPO?.factibilidad || 'Factibilidad no disponible'}
        </div>
      ),
    },
    {
      key: '4',
      span: 3,
      label: (
        <div style={{ textAlign: 'left' }}>
          {headerPO?.territorio_zona || 'Territorio / Zona PDET no disponible'}
        </div>
      ),
    },
    {
      key: '5',
      span: 3,
      label: (
        <div style={{ textAlign: 'left' }}>
          <strong>Tiempo de Duración:</strong>{' '}
          {headerPO?.duracion ?? 'Duración no disponible'}
        </div>
      ),
    },
    {
      key: '6',
      span: 1,
      label: (
        <div style={{ textAlign: 'left' }}>
          <strong>Fecha Inicio:</strong>{' '}
          {formatDateToText(headerPO?.fecha_inicio)}
        </div>
      ),
    },
    {
      key: '7',
      span: 1,
      label: (
        <div style={{ textAlign: 'left' }}>
          <strong>
            {tieneFechaActualTerminacion
              ? 'Fecha inicial de terminación:'
              : 'Fecha Terminación:'}
          </strong>{' '}
          {formatDateToText(headerPO?.fecha_terminacion)}
        </div>
      ),
    },
    ...(tieneFechaActualTerminacion
      ? [
        {
          key: '8',
          span: 1,
          label: (
            <div style={{ textAlign: 'left' }}>
              <strong>Fecha actual de terminación:</strong>{' '}
              {formatDateToText(headerPO.fecha_actual_terminacion)}
            </div>
          ),
        },
      ]
      : []),
  ];



  const formatFechaToISO = (fecha) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      const [year, month, day] = fecha.split('-');
      const formattedDate = new Date(year, month - 1, day);
      if (isNaN(formattedDate)) {
        throw new Error(`Fecha no válida: ${fecha}`);
      }
      return formattedDate.toISOString();
    }

    // Detecta si la fecha está en formato DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
      const [day, month, year] = fecha.split('/');
      const formattedDate = new Date(year, month - 1, day);
      if (isNaN(formattedDate)) {
        throw new Error(`Fecha no válida: ${fecha}`);
      }
      return formattedDate.toISOString();
    }

    // Si no coincide con ninguno de los formatos, lanza un error
    throw new Error(`Formato de fecha inválido: ${fecha}`);
  };

  const handleSaveDate = async (value, record) => {
    const codIndicador = record.codIndicador;
    const newfechaFinReal = value.fechaFinReal;
    const tipo = 'medio_verificacion';
    const newData = [...actividades];
    newData.forEach((actividad) => {
      actividad.children.forEach((tarea) => {
        tarea.children.forEach((cronograma) => {
          if (cronograma.id === codIndicador) {
            cronograma.fecha_f_real = newfechaFinReal;
          }
        });
      });
    });
    setActividades(newData);
    setTareasSubtareas(mapTareasSubtareas(newData));
    try {
      const response = await updateFecha(codIndicador, newfechaFinReal, tipo);
      if (response.status === 200) {
        message.success('Registro actualizado correctamente');
      } else {
        message.error('No se pudo actualizar el avance');
      }
    } catch (error) {
      console.error('Error en handleSaveDate:', error);
      message.error('Error al actualizar el avance');
    }
  };

  const handleSave = async (value, key, dataIndex) => {

    const valorActualizado = value[dataIndex];
    if (valorActualizado === undefined || valorActualizado === null) {
      return; // No hacer nada si es undefined o null
    }

    const newData = [...actividades];
    newData.forEach(actividad => {
      actividad.children.forEach(tarea => {
        tarea.children.forEach(cronograma => {
          const cronogramaP = cronograma.cronogramasP.find(item => item.id === Number(key));
          const cronogramaE = cronograma.cronogramasE.find(item => item.id === Number(key));
          if (cronogramaP) {

            cronogramaP.avance = valorActualizado;
          }
          if (cronogramaE) {

            cronogramaE.avance = valorActualizado;
          }
        });
      });
    });
    setActividades(newData);
    setTareasSubtareas(mapTareasSubtareas(newData));

    try {
      const response = await updateAvance(key, valorActualizado);
      if (response.status === 200) {
        message.success('Avance actualizado correctamente');

        // Actualizamos el JSON raw para recalcular totales sin volver a consumir el servicio.
        setRawPesoData(prevRaw => {
          const newRaw = updateAvanceInRaw(prevRaw, key, Number(valorActualizado));
          return newRaw;
        });


      }
    } catch (error) {
      message.error('Error al actualizar el avance: '); // Muestra un mensaje de error
    }
  };


  const handleSavePeso = async (updatedRecord) => {

    const valorActualizado = updatedRecord.pesoPorcentual;
    if (valorActualizado === undefined || valorActualizado === null) {
      return; // No hacer nada si es undefined o null
    }

    // Supongamos que identificamos la tarea por tarea.id o record.oidTarea.
    // Por ejemplo, usaremos "oidTarea" (asegúrate de que cada tarea tenga este campo único).
    const rowId = updatedRecord.oidTarea;
    let oldValue = null;

    // Creamos una copia del array de actividades
    const newData = [...actividades];

    // Recorremos las actividades
    newData.forEach((actividad) => {
      if (!actividad.children) return;

      actividad.children.forEach((tarea) => {
        // Si la tarea coincide con el id, actualizamos su pesoPorcentual
        if (tarea.oidTarea === rowId || tarea.id === rowId) {

          oldValue = Number(tarea.pesoPorcentual || 0);
          tarea.pesoPorcentual = valorActualizado;
          return { ...tarea, pesoPorcentual: Number(valorActualizado) };
        }
      });
    });

    // Actualizamos el estado con la nueva data
    setActividades(newData);
    setTareasSubtareas(mapTareasSubtareas(newData));

    // Si hemos obtenido el valor anterior, calculamos el delta y ajustamos pesoTotal
    if (oldValue !== null) {

      const delta = Number(valorActualizado) - oldValue;

      const nuevoTotal = pesoTotal + delta;

      setPesoTotal(nuevoTotal);


      if (nuevoTotal > 100) {
        Modal.confirm({
          title: 'Advertencia: Peso Excedido',
          content: (
            <div>
              El peso porcentual ingresado excede la sumatoria del 100% para la Fase I y Fase II.
              Ajuste el valor ingresado para evitar errores en el cálculo de avance de las actividades.
            </div>
          ),
          centered: true,
          okText: 'Cerrar',
          cancelText: 'Cancelar',
          onOk() {
            // Acciones a realizar cuando se presiona "Cerrar"
          },
          onCancel() {
            // Acciones a realizar cuando se presiona "Cancelar"
          },
        });
      }
    }

    try {
      const response = await updatePeso(rowId, valorActualizado); // Asegúrate de tener updatePeso definido
      if (response.status === 200) {
        message.success('Peso actualizado correctamente');

        setRawPesoData((prevRaw) => {

          const newJson = updatePesoInJson(prevRaw, rowId, Number(valorActualizado));
          return newJson;
        });

      }
    } catch (error) {
      message.error('Error al actualizar el peso');
    }
  };

  // Función para actualizar el peso en el JSON "raw" (que es un arreglo de actividades)
  const updatePesoInJson = (jsonArray, rowId, newValue) => {

    if (!jsonArray) return []; // Retorna un arreglo vacío si jsonArray es null o undefined

    // Recorremos cada actividad
    return jsonArray.map((actividad) => ({
      ...actividad,
      // Si la actividad tiene tareas ("children"), las actualizamos
      children: actividad.children
        ? actividad.children.map((tarea) => {
          // Si la tarea coincide con el rowId (puedes usar tarea.id o tarea.oidTarea)
          if (tarea.id === rowId || tarea.oidTarea === rowId) {
            // Actualizamos la propiedad "pesoPorcentual"
            return { ...tarea, pesoPorcentual: newValue };
          }
          // Si no, la dejamos igual
          return tarea;
        })
        : actividad.children,
    }));
  };

  const esIndicadorInformeFinal = (indicador) => /informe[\s\S]*final/i.test(indicador || '');

  const handleNoInfoClick = (datos) => {
    setBanderaProyecto(selectedProject.codigo);
    setActividadSelect(datos);
    setEsInformeFinalSoporte(esIndicadorInformeFinal(datos?.indicador));
    showModal();
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setBanderaProyecto(null)
    setActividadSelect(null);
    setEsInformeFinalSoporte(false);
    setIsModalVisible(false);
  };

  const cellStyle = { padding: '2px 5px' };






  const columnss = [
    ...(isVisibleTarea
      ? [
        {
          title: 'Tarea',
          dataIndex: 'tarea',
          key: 'tarea',
          fixed: 'left',
          width: 300,
          ellipsis: false,
          onCell: (record, rowIndex) => ({
            rowSpan: rowIndex % 2 === 0 ? 2 : 0, style: cellStyle
          }),
          render: (text, record, rowIndex) =>
            rowIndex % 2 === 0 ? (
              <div
                style={{
                  width: '482px',
                  whiteSpace: 'pre-line',
                  wordWrap: 'break-word',
                  textAlign: 'justify',
                }}
              >
                {text}
              </div>
            ) : null,
        },
      ]
      : []),

    {
      title: 'Indicador',
      dataIndex: 'indicador',
      key: 'indicador',

      width: 50,
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              display: 'block', // o 'inline-block'
              whiteSpace: 'nowrap', // Impide saltos de línea
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '300px',
              minWidth: '300px',
              maxWidth: '300px',
              lineHeight: .9,
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
      onCell: (record, rowIndex) => ({
        rowSpan: rowIndex % 2 === 0 ? 2 : 0,
      }),
    },

    {
      title: 'Meta',
      dataIndex: 'meta',
      key: 'meta',
      width: 100,
      fixed: 'left',
      align: 'center',
      onCell: (record, rowIndex) => ({
        rowSpan: rowIndex % 2 === 0 ? 2 : 0,
      }),
      render: (value) => {
        // Asegurar que el valor sea un número
        const numValue = Number(value); // Convertimos a número si viene como string

        if (isNaN(numValue)) {
          return '-'; // Valor por defecto si no es un número
        }

        // Extraemos la parte decimal
        const decimalPart = numValue % 1;

        // Si la parte decimal es menor o igual a 0.1, mostrar solo el entero
        return decimalPart <= 0.1 ? Math.trunc(numValue) : numValue.toFixed(1);
      },
    },
    { title: 'Fecha Inicio', dataIndex: 'fechaInicio', key: 'fechaInicio', width: 150, onCell: (record, rowIndex) => ({ rowSpan: rowIndex % 2 === 0 ? 2 : 0, }) },
    { title: 'Fecha Fin', dataIndex: 'fechaFin', key: 'fechaFin', width: 150, onCell: (record, rowIndex) => ({ rowSpan: rowIndex % 2 === 0 ? 2 : 0, }) },
    { title: 'P/E', dataIndex: 'pe', key: 'pe', width: 50, align: 'center', fixed: 'left' },

    ...columnasFinales,


    {
      title: 'Seguimiento Acumulado', children: [
        { title: 'Meta y Avance Acumulado', dataIndex: 'metaAcu', key: 'metaAcu', width: 150, render: (value) => value || '-', align: 'center' },
        { title: '% de Avance Acumulado', dataIndex: 'avanceAcu', key: 'avanceAcu', width: 100, render: (text) => { const progreso = parseFloat(text); const { color, backgroundColor } = getAvanceStyle(progreso); return (<div style={{ color, backgroundColor }}>{text}</div>); }, align: 'center', onCell: (record, rowIndex) => ({ rowSpan: rowIndex % 2 === 0 ? 2 : 0, }) }
      ]
    },

    ...(!tipoFase
      ? [
        {
          title: (
            <Tooltip
              title={`*Asignar el peso porcentual según la relevancia de la actividad en el proyecto.`}
            >
              <div
                style={{
                  display: 'block', // o 'inline-block'
                  whiteSpace: 'nowrap', // Impide saltos de línea
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '200px',
                  minWidth: '200px',
                  maxWidth: '200px',
                  lineHeight: .9,
                  textAlign: 'center',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  PESO PORCENTUAL <br />
                  (
                  <span style={{ fontSize: '1em' }}>
                    {pesoTotal.toFixed(0)}%
                  </span>
                  )
                </div>
                <hr />
                <div style={{ textAlign: 'center' }}>
                  PESO PORCENTUAL <br />
                  {selectedFase.nombre_corto} <br />
                  (
                  <span style={{ fontSize: '1em' }}>
                    {totalPesoFase.toFixed(0)}%
                  </span>
                  )
                </div>
              </div>
            </Tooltip>
          ),
          dataIndex: 'pesoPorcentual',
          key: 'pesoPorcentual',
          width: 200,
          align: 'center',
          render: (text) => `${text}%`,
          onCell: (record, rowIndex) => ({
            record,
            editable: permissionView,
            dataIndex: 'pesoPorcentual',  // <-- PASAR el dataIndex
            dataType: 'integer',
            handleSave: (updatedRecord) => {
              // Este "updatedRecord" es el objeto que envía EditableCell
              // Llamas tu función handleSavePeso
              handleSavePeso(updatedRecord);
            },
            rowSpan: rowIndex % 2 === 0 ? 2 : 0
          }),
        },
      ] : []),
    {
      title: 'FECHA FIN REAL',
      dataIndex: 'fechaFinReal',
      key: 'fechaFinReal',
      width: 150,
      align: 'center',
      editable: permissionInsert,
      render: (text, record) => {
        if (!text || text === 'Sin fecha') {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                margin: '2px',
              }}
            >
              <span>Sin fecha</span>
              <Tooltip title="Por favor diligenciar este campo, con la fecha en la que se realizó la tarea, en formato dd/mm/año">
                <WarningOutlined
                  style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                />
              </Tooltip>
            </div>
          );
        }
        return text;
      },
      onCell: (record, rowIndex) => ({
        record,
        editable: permissionInsert,
        dataType: 'date',
        handleSave: (value) =>
          handleSaveDate(value, record),
        rowSpan: rowIndex % 2 === 0 ? 2 : 0,
      }),
    },
    {
      title: 'MEDIO DE VERIFICACIÓN', 
      dataIndex: 'medioVerificacion',
      key: 'medioVerificacion',
      width: 250,
      ellipsis: false,
      onCell: (record, rowIndex) => ({ rowSpan: rowIndex % 2 === 0 ? 2 : 0, }),
      render: (text) => (
        <div style={{ width: '400px', whiteSpace: 'pre-line', wordWrap: 'break-word', textAlign: 'justify' }}>
          {text}
        </div>
      ),
    },
    ...(permissionUpdate
      ? [
        {
          title: "Ruta Soportes",
          dataIndex: "ruta",
          align: "center",
          key: "ruta",
          width: 150,
          onCell: (record, rowIndex) => ({ rowSpan: rowIndex % 2 === 0 ? 2 : 0 }),
          render: (text, record) => {
            //SIN RUTA POA, PLAN OPERATIVO
            if (!text) {
              return (
                <Tooltip title="No hay información disponible">
                  <InfoCircleOutlined
                    style={{ fontSize: "16px", color: "#8ABF45", cursor: "pointer" }}
                    onClick={() => handleNoInfoClick(record)}
                  />
                </Tooltip>
              );
            }

            const contentRegex = /{([^{}]+)}/g;
            let matches = [...text.matchAll(contentRegex)];
            //RUTA POA
            if (matches.length === 0) {
              return text.startsWith("https://") ? (
                <Tooltip title={text}>
                  <LinkOutlined
                    style={{ fontSize: "16px", color: "#317EDA", cursor: "pointer" }}
                    onClick={() => handleClickBasedOnURL(text, record)}
                  />
                </Tooltip>
              ) : (
                <Tooltip title={text}>
                  <InfoCircleOutlined
                    style={{ fontSize: "16px", color: "#8ABF45", cursor: "pointer" }}
                    onClick={() => handleNoInfoClick(record)}
                  />
                </Tooltip>
              );
            }

            let elements = matches.map((match, index) => {
              let content = match[1].trim();
              return content.startsWith("https://") ? (
                <Tooltip key={`url-${index}`} title={content}>
                  <LinkOutlined
                    style={{ fontSize: "16px", color: "#317EDA", cursor: "pointer" }}
                    onClick={() => handleClickBasedOnURL(content, record)}
                  />
                </Tooltip>
              ) : (
                <Tooltip key={`text-${index}`} title={content}>
                  <InfoCircleOutlined
                    style={{ fontSize: "16px", color: "#8ABF45", cursor: "pointer" }}
                    onClick={() => handleNoInfoClick(record)}
                  />
                </Tooltip>
              );
            });

            return <Space>{elements}</Space>;
          },
        },
      ]
      : []),
  ];



  const getAvanceStyle = (progreso) => {
    const color = progreso < 30 ? 'red' : progreso < 60 ? 'orange' : 'green';
    const backgroundColor = progreso < 30 ? 'rgba(255, 0, 0, 0.1)' : progreso < 60 ? 'rgba(255, 165, 0, 0.1)' : 'rgba(0, 128, 0, 0.1)';
    return { color, backgroundColor };
  };


  const panelItems = actividades.map((actividad) => ({
    key: actividad.codigo_actividad,
    label: (

      <span style={{ color: 'white', marginRight: '8px' }}>
        Actividad: {actividad.codigo_actividad} - {actividad.descripcion}
      </span>

    ),
    style: {
      backgroundColor: '#042956',
      color: 'white',
      margin: '0px',
    },
    children: (
      <div className="tabla-container">

        {mostrarTablaCronograma && (
          <div className="custom-ant-table-wrapper">
            <Table
              bordered
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              width="100%"
              className="table-curso-fortalecimiento"
              columns={columnss}
              dataSource={tareasSubtareas.filter((tarea) => tarea.oidActividad === actividad.id)}
              pagination={false}
              loading={loading}
              scroll={{
                x: 'max-content',
                y: 600,
              }}
              size="small"
              rowClassName={(record, index) =>
                index === filaSeleccionada ? 'fila-seleccionada' : 'fila-normal'
              }
              onRow={(record, index) => ({
                onClick: () => setFilaSeleccionada(index),
              })}

            />
          </div>
        )}

        {permissionPrint && (
          <>
            {mostrarTablaResumen && !tipoFase && (
              <div style={{ width: '100%' }}>
                {/* Título fijo fuera del contenedor con scroll */}
                <div className="titleTable">
                  <hr />
                  <h3 className="titleResumen">Resumen avance en la ejecución</h3>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <TablaAvanceJSX valoresJsonPeso={valoresJsonPeso} modo='filtro' />
                </div>

              </div>
            )}
          </>)}

      </div>
    ),
  }));



  const toggleVisibility = () => {
    setIsVisible(!isVisible); // Cambiar el estado entre visible y oculto
  };

  const regresar = () => {
    regresarAnterior();
    setEditingDate(false);
    cerrarModal();
  };

  const handleEditDateClick = () => {
    setEditingDate(true);
  };

  const handleDateChange = async (date, dateString, headerPO) => {
    if (date && headerPO) {
      const fecha = dayjs(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD');
      const oid = headerPO?.children?.[0]?.id;
      const tipo = "detalle";
      const updatedHeaderPO = { ...headerPO };
      updatedHeaderPO.fecha_corte = formatFechaToISO(fecha);
      if (updatedHeaderPO.children && updatedHeaderPO.children.length > 0) {
        updatedHeaderPO.children[0].fecha_corte = formatFechaToISO(fecha);
      }
      try {
        await updateFecha(oid, fecha, tipo);
        setHeaderPO(updatedHeaderPO);
        setEditingDate(false);
        message.success('Fecha actualizada correctamente');
      } catch (error) {
        message.error('Hubo un error al actualizar la fecha');
        console.error('Error al actualizar la fecha:', error);
      }
    }
  };


  return (
    <div className="">
      <style>{estilosDinamicosAnios}</style>
      <Layout>
        <div className="d-flex justify-content-center">
          <div className="d-flex justify-content-center" style={{ gap: "10px" }}>
            <Tooltip title="Regresar">
              <Button
                type="primary"
                shape="circle"
                icon={<ArrowLeftOutlined />}
                onClick={regresar}
              />
            </Tooltip>
            <Tooltip title={isVisible ? "Cerrar contenido" : "Abrir contenido"}>
              <Button
                type="primary"
                shape="circle"
                icon={isVisible ? <MoreOutlined /> : <MenuOutlined />}
                onClick={toggleVisibility}
              />
            </Tooltip>
          </div>
        </div>
        <div className="d-flex justify-content-center gap-3">
          {isVisible && (
            <>
              <Card
                style={{ marginTop: 16, width: tieneFechaActualTerminacion ? '100%' : '80%' }}
              >
                <Descriptions
                  title=""
                  layout="vertical"
                  bordered
                  items={items}
                />
              </Card>
              <div style={{ paddingTop: '15px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Title
                  level={4}
                  className="gradient-text"
                  style={{
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {selectedProject.codigo} - {selectedProject.proyecto}
                </Title>
                <p style={{ fontSize: '16px', fontWeight: 'bold', margin: 0 }}>
                  Fecha de Corte de Avances:
                </p>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '16px',
                    border: '1px solid #A19E9E',
                    fontWeight: 'bold',
                    padding: '5px',
                    borderRadius: '4px',
                    margin: 0,
                    width: '270px',
                    cursor: permissionInsert ? 'pointer' : 'not-allowed',
                    backgroundColor: permissionInsert ? 'white' : '#f8f9fa',
                  }}
                  onClick={() => {
                    if (permissionInsert) {
                      handleEditDateClick();
                    }
                  }}
                >
                  {editingDate ? (
                    <DatePicker
                      style={{ width: '270px', }}
                      onChange={(date, dateString) => handleDateChange(date, dateString, headerPO)}
                      value={
                        headerPO?.fecha_corte
                          ? dayjs(headerPO.fecha_corte)
                          : null
                      }
                      format="DD/MM/YYYY"
                    />
                  ) : headerPO?.fecha_corte ? (
                    <span>{moment(headerPO.fecha_corte).format('DD/MM/YYYY')}</span>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '8px 12px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '4px',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                      }}
                    >
                      <span
                        style={{
                          color: '#575757',
                          fontSize: '14px',
                          textAlign: 'center',
                        }}
                      >
                        Haz clic para registrar la fecha
                      </span>
                      <Tooltip title="*Por favor diligenciar este campo, con la fecha de corte en la que se actualizaron las metas ejecutadas del POA.">
                        <WarningOutlined style={{ fontSize: '20px', color: 'red', cursor: 'pointer' }} />
                      </Tooltip>
                    </div>
                  )}
                </div>
                {headerPO?.fecha_corte ? (
                  null
                ) : (
                  <Tooltip title="**Por favor diligenciar este campo, con la fecha de corte en la que se actualizaron las metas ejecutadas del POA.">
                    <WarningOutlined style={{ fontSize: '20px', color: 'red', cursor: 'pointer' }} />
                  </Tooltip>
                )}
              </div>
            </>
          )}
          {!isVisible && (
            <div
              style={{
                paddingTop: '15px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Title
                level={4}
                className="gradient-text"
                style={{ margin: 0 }}
              >
                {selectedProject.codigo} - {selectedProject.proyecto}
              </Title>

              <p style={{ fontSize: '16px', fontWeight: 'bold', margin: 0 }}>
                Fecha de Corte de Avancess:
              </p>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontSize: '16px',
                  border: '1px solid #A19E9E',
                  fontWeight: 'bold',
                  padding: '5px',
                  borderRadius: '4px',
                  margin: 0,
                  width: '270px',
                }}
                onClick={handleEditDateClick}
              >
                {editingDate ? (
                  <DatePicker
                    style={{ width: '270px' }}
                    onChange={(date, dateString) => handleDateChange(date, dateString, headerPO)}
                    value={
                      headerPO?.fecha_corte
                        ? dayjs(headerPO.fecha_corte)
                        : null
                    }
                    format="DD/MM/YYYY"
                  />
                ) : headerPO?.fecha_corte ? (
                  <span>
                    {moment(headerPO.fecha_corte).format('DD/MM/YYYY')}
                  </span>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: '#575757' }}>
                      Haz clic para registrar la fecha
                    </span>
                    <Tooltip title="*Por favor diligenciar este campo, con la fecha de corte en la que se actualizaron las metas ejecutadas del POA.">
                      <WarningOutlined
                        style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
              {!headerPO?.fecha_corte && (
                <Tooltip title="*Por favor diligenciar este campo, con la fecha de corte en la que se actualizaron las metas ejecutadas del POA.">
                  <WarningOutlined
                    style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                  />
                </Tooltip>


              )}
            </div>
          )}
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Title
              level={4}
              className="justified-title"
              style={{ marginTop: '10px', marginRight: '16px' }} // separa el título del icono
            >
              {selectedFase.nombre_corto}
            </Title>

            <div style={{ display: 'flex', alignItems: 'center' }}>

              {!tipoFase && (
                <>
                  <span
                    onClick={toggleTablaResumen}
                    style={{ color: 'red', cursor: 'pointer', fontSize: '20px', marginRight: '16px' }} // aumenta el tamaño del icono
                  >

                    <Tooltip title={`Mostrar u ocultar el resumen de avance en la ejecución.`}>
                      <TableOutlined style={{ color: mostrarTablaCronograma ? 'green' : 'gray', fontSize: '20px' }} />

                    </Tooltip>

                  </span>
                  <span
                    onClick={toggleTablaCronograma}
                    style={{ color: 'red', cursor: 'pointer', fontSize: '20px' }} // aumenta el tamaño del icono
                  >

                    <Tooltip title={`Mostrar u ocultar cronograma.`}>
                      <EyeOutlined style={{ color: mostrarTablaResumen ? 'green' : 'gray', fontSize: '20px', marginRight: '16px' }} />
                    </Tooltip>

                  </span>
                </>
              )}

              <span
                onClick={toggleVisibilityTarea}
                style={{ color: 'red', cursor: 'pointer', fontSize: '20px', marginRight: '16px' }} // aumenta el tamaño del icono
              >
                <Tooltip title={`Mostrar u ocultar la columna Tarea.`}>
                  <ColumnHeightOutlined style={{ color: toggleVisibilityTarea ? 'green' : 'gray', fontSize: '20px' }} />
                </Tooltip>
              </span>
            </div>
          </div>
          <Collapse accordion items={panelItems} />
        </div>
        <div className="d-flex justify-content-center">
          <Modal
            title={<span className="custom-modal-title">Medios de verificación</span>}
            open={isModalVisible}
            onCancel={hideModal}
            destroyOnHidden
            footer={null}
            width="95%"
            style={{ top: 20 }}
          >
            <FileManagerPOA2 codigo_tarea={actividadSelect} select_proyect={banderaProyecto} esInformeFinal={esInformeFinalSoporte} />
          </Modal>
        </div>
        <div className="d-flex justify-content-center">
          <Modal
            title={<span className="custom-modal-title">Medios de verificación</span>}
            open={openModal1}
            destroyOnHidden={true}
            onCancel={hideModalMedios}
            footer={null}
            width="95%"
            style={{ top: 20 }}
          >
            <FileManagerPOA codigo_tarea={{ codigo_tarea: itemParams }} onClose={hideModalMedios} />
          </Modal>
        </div>
        <div>
          <Modal
            title=""
            open={isModalVisibleParticipantes}
            onCancel={handleCancelParticipantes}
            footer={null}
            width="95%"
            style={{ top: 10 }}
          >
            {renderComponent()}
          </Modal>
        </div>
      </Layout>
    </div>
  );
};

export default PoaPlanOperativoTB;
